import { ReportViewerSnackbarComponent } from './report-viewer-snackbar/report-viewer-snackbar.component';
import { WithNavbarComponent } from './with-navbar/with-navbar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { ReportViewerMenuComponent } from './report-viewer-menu/report-viewer-menu.component';

export const components = [
  ReportViewerSnackbarComponent,
  WithNavbarComponent,
  NavbarComponent,
  ReportViewerMenuComponent,
];
